import { createContractRequest } from './helper';
export const getOffer = createContractRequest({
    route: '/contract/offers/:offerId',
    method: 'get',
    source: 'data',
});
